import styled from 'styled-components';
import { Link } from 'react-router-dom';

import {
  LinkStyled,
  font14,
  fontWeightNormal,
} from 'approot/shared/styles/typography.style';
import {
  grey2,
  grey4,
  grey7,
  grey8,
  purple8,
} from 'approot/shared/styles/colours.style';
import { rem, mediaUp } from 'approot/shared/style';
import {
  spacing8,
  spacing16,
  spacing24,
  spacing40,
} from 'approot/shared/styles/spacing.style';
import { Heading16 } from 'approot/shared/styles/typography.style';
import {
  baseLayoutBounds,
  LAYOUT_FOOTER_TOP_SPACING,
  LAYOUT_CONTENTS_MAX_WIDTH,
  LAYOUT_SIDE_PADDING,
} from 'approot/shared/layout/layout.styles';
import { standardFocusState } from 'approot/shared/styles/borders.style';
import { HrStyled } from 'approot/shared/styles/decorative.style';
import { LinkButton } from 'approot/shared/styles/buttons/buttons';
import { fadeInContent } from 'approot/shared/styles/transitions.style';

export const Footer = styled.footer`
  background-color: ${grey2};
  border-top: 1px solid ${grey4};
  color: ${grey8};
  min-height: ${rem(200)};
  padding-bottom: calc(env(safe-area-inset-bottom));
  ${mediaUp.xl`
    padding-bottom: 0;
  `}
`;

export const FooterWrapper = styled.div`
  ${baseLayoutBounds}

  margin: auto;
  max-width: ${rem(LAYOUT_CONTENTS_MAX_WIDTH + LAYOUT_SIDE_PADDING * 2)};
  padding-top: ${rem(LAYOUT_FOOTER_TOP_SPACING)};
  padding-bottom: ${rem(spacing16)};

  ${mediaUp.md`
    max-width: ${rem(1284)};
  `}
`;

export const FooterBreakStyled = styled.hr`
  border-top-color: ${grey4};
  margin: ${rem(spacing16)} 0;
`;

export const FooterMainContainer = styled.div`
  display: flex;
`;

export const FooterLogoContainer = styled.div`
  width: ${rem(240)};
  flex-shrink: 0;
`;

export const FooterNavContainer = styled.div`
  margin-bottom: ${rem(spacing24)};
`;

export const FooterLogoStyled = styled.span`
  display: inline-block;
  vertical-align: middle;
  height: ${rem(28)};
  width: ${rem(108)};
`;

export const FooterGroup = styled.ul`
  margin: 0;
  padding: 0;

  li {
    list-style: none;
    margin-bottom: ${rem(spacing8)};

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const FooterLessonsGroup = styled(FooterGroup)`
  display: flex;
  flex-wrap: wrap;

  li {
    width: 50%;
  }
`;

export const FooterLinkStyled = styled(Link)`
  ${font14}
  ${standardFocusState}
  border-radius: ${rem(4)};
  display: inline-block;
  text-decoration: none;
`;

export const FooterLinksFadeIn = styled.div`
  ${fadeInContent}
`;

export const FooterAnchorStyled = styled.a`
  ${font14}
  ${standardFocusState}
  border-radius: ${rem(4)};
  display: inline-block;
  text-decoration: none;
`;

export const FooterButtonStyled = styled(LinkButton)`
  ${font14}
  ${standardFocusState}
  border-radius: ${rem(4)};
  display: inline-block;
  text-decoration: none;
  color: ${grey8};
  text-align: left;

  &:hover,
  &:focus {
    color: ${purple8};
    text-decoration: none;
  }
`;

export const FooterSocialsGroupStyled = styled.div`
  li {
    display: inline-block;
    list-style: none;
    margin-right: ${rem(spacing8)};
    &:last-child {
      margin: 0;
    }
  }

  ul {
    margin: 0;
    padding: 0;
  }
`;

export const FooterSocialLinkStyled = styled.a`
  border-radius: ${rem(4)};
  display: inline-block;
  padding: ${rem(2)};
  width: ${rem(25)};
  height: ${rem(25)};

  svg {
    height: 100%;
    width: 100%;
  }

  ${standardFocusState}
`;

export const FooterSpaceBetween = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: ${rem(spacing40)} 0;
`;

export const FooterReferLink = styled(LinkStyled)`
  ${font14}
  font-weight: ${fontWeightNormal};
  color: ${grey7};
  margin-left: ${rem(spacing8)};
`;

export const FooterGroupHeading = styled(Heading16).attrs({ as: 'h2' })`
  ${font14}
  margin: 0;
`;

export const FooterNavHR = styled(HrStyled).attrs({
  marginTop: spacing8,
  marginBottom: spacing8,
})``;

type FooterTextProps = {
  noBottomMargin?: boolean;
  maxWidth?: number;
};
export const FooterTextStyled = styled.p<FooterTextProps>`
  ${font14}

  ${({ noBottomMargin }) =>
    noBottomMargin &&
    `
    margin-bottom: 0;
  `};
  ${({ maxWidth }) =>
    maxWidth &&
    `
    max-width: ${rem(maxWidth)};
  `};
`;
